import api from 'src/config/api';
import { CollectionResponse } from 'src/interfaces/api/api';
import { getJsonResponse } from 'src/utils/ApiUtils';
import Customer, { CreateCustomerOptions } from 'src/interfaces/api/Customer';
import useAuth from './useAuth';

const useCustomer = () => {
  const { fetch } = useAuth();

  const create = async (customer: CreateCustomerOptions): Promise<Customer> => {
    const { endpoint, ...options } = api.customer.create(customer);

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<Customer>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const getAll = async (name: string, page: number, limit: number): Promise<CollectionResponse<Customer>> => {
    const { endpoint, ...options } = api.customer.getAll(name, page, limit);

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<CollectionResponse<Customer>>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  return { getAll, create };
};

export default useCustomer;
